var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 19.4582H2.49984C1.69984 19.4582 1.0415 18.7998 1.0415 17.9998V7.1665C1.0415 3.48317 2.98317 1.5415 6.6665 1.5415H13.3332C17.0165 1.5415 18.9582 3.48317 18.9582 7.1665V13.8332C18.9582 17.5165 17.0165 19.4582 13.3332 19.4582ZM6.6665 2.7915C3.68317 2.7915 2.2915 4.18317 2.2915 7.1665V17.9998C2.2915 18.1165 2.38317 18.2082 2.49984 18.2082H13.3332C16.3165 18.2082 17.7082 16.8165 17.7082 13.8332V7.1665C17.7082 4.18317 16.3165 2.7915 13.3332 2.7915H6.6665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 9.0415H5.8335C5.49183 9.0415 5.2085 8.75817 5.2085 8.4165C5.2085 8.07484 5.49183 7.7915 5.8335 7.7915H14.1668C14.5085 7.7915 14.7918 8.07484 14.7918 8.4165C14.7918 8.75817 14.5085 9.0415 14.1668 9.0415Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 13.2085H5.8335C5.49183 13.2085 5.2085 12.9252 5.2085 12.5835C5.2085 12.2418 5.49183 11.9585 5.8335 11.9585H11.6668C12.0085 11.9585 12.2918 12.2418 12.2918 12.5835C12.2918 12.9252 12.0085 13.2085 11.6668 13.2085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.54f581ccc14bfa8dfd025ea14e448471.svg";
export { ForwardRef as ReactComponent };